import jsFileDownload from 'js-file-download'
import filenamify from 'filenamify'
import dayjs from 'shared/dayjs'

export const downloadAsFile = (
  fileData: string,
  prefix: string,
  extension = 'csv'
) => {
  jsFileDownload(
    fileData,
    `${prefix}-${filenamify(dayjs().format(), {
      replacement: '-'
    })}.${extension}`
  )
}
